import * as stylex from '@stylexjs/stylex';
import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { Checkbox } from '@/core/Checkbox.atom';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import { getFormFieldProps, getFormFieldWrapperProps } from '@/formbuilder/formbuilder.utilities';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface CheckboxIF extends ValidatingFormComponent<boolean> {
  checkboxXstyle?: stylex.StyleXStyles;
  component: 'CheckboxFormComponent';
  id: string;
  onChange?: (value: boolean) => void;
  checkboxLabel: string;
  translateLabel?: boolean;
  type?: 'radio' | 'checkbox';
  disabled?: boolean;
  classes?: string;
  onHelpIconClick?: () => any;
  extraLabelClassNames?: string;
}

export const CheckboxFormComponent = (props: CheckboxIF) => {
  const { name, value, validation, classes, skipToFormState, onHelpIconClick, checkboxLabel, customErrorText } = props;

  const formState = useForm().getState();
  const defaultValidation = () => false;
  const appliedValidation = _.isFunction(validation) ? validation : defaultValidation;
  const showError =
    _.has(formState.errors, name) &&
    formState.hasValidationErrors &&
    ((formState.modified && formState.modified[name]) || formState.submitFailed);

  return (
    <FormFieldWrapper
      {...getFormFieldWrapperProps(props, ['id', 'tooltip'])}
      showError={showError}
      customErrorText={customErrorText}>
      <Field<boolean> name={name} validate={appliedValidation} type="checkbox">
        {({ input, meta }) => (
          <Checkbox
            {..._.omit(getFormFieldProps(formState, input, meta, props), 'label', 'checkboxLabel')}
            classes={classes}
            xstyle={[styles.checkbox, props.xstyle]}
            isChecked={skipToFormState ? input.checked : value}
            onHelpIconClick={onHelpIconClick}
            label={checkboxLabel}
          />
        )}
      </Field>
    </FormFieldWrapper>
  );
};

const styles = stylex.create({
  checkbox: { display: 'flex', flexDirection: 'row', flex: '1 1 auto', overflow: 'hidden', alignItems: 'flex-start' },
});
